var map = {
	"./images/hashed.png": 1830
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1829;


//////////////////
// WEBPACK FOOTER
// ./src/resources/page/home/partners ^.*\/hashed\.png$
// module id = 1829
// module chunks = 146